import requestModel from "services/config/apiHandlers";

interface IWallets {
  url: string;
  requestObj: Object;
}
class Wallets implements IWallets {
  url: string;
  requestObj: Object;
  constructor(requestObj: Object = {}) {
    this.requestObj = requestObj;
    this.url = "api/wallets/";
  }

  async getWallet() {
    const apiObj = {
      url: this.url + "user",
    };

    return await requestModel.response(apiObj);
  }
}

export default Wallets;
